export const environment = {
  production: false,
  useMocks: false,  
  apiBaseUrl: 'https://app-ptq-qa-eastus-legajostecnicos-ftdcc6a0ceexgheu.eastus-01.azurewebsites.net/api',

  clientId: '777d8513-9944-4a35-8429-cc68f2bf85ef',
  tenantId: 'eef41338-8caf-4011-87bf-ff1c9c425f9e',
  redirectURL: 'https://legajostecnicosqa.espaciopampa.com/',
};